import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const InteractiveMap = ({ technicianLocation, customerLocation, eta }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  const formatETA = (minutes) => {
    if (minutes < 60) {
      return `${minutes} min`;
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins}min`;
  };

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border overflow-hidden">
      <div className="relative" style={{ height: '400px' }}>
        {isLoading ? (
          <div className="absolute inset-0 flex items-center justify-center bg-muted">
            <div className="flex flex-col items-center gap-3">
              <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
              <p className="text-sm text-muted-foreground">Chargement de la carte...</p>
            </div>
          </div>
        ) : (
          <>
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title="Localisation du technicien"
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${technicianLocation?.lat},${technicianLocation?.lng}&z=14&output=embed`}
              className="w-full h-full"
            />
            
            <div className="absolute top-4 left-4 right-4 flex justify-between items-start gap-3">
              <div className="bg-card/95 backdrop-blur-sm rounded-lg p-3 shadow-lg border border-border flex items-center gap-3 flex-1">
                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
                  <Icon name="Navigation" size={20} color="#FFFFFF" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-muted-foreground">Arrivée estimée</p>
                  <p className="text-lg font-semibold text-foreground">{formatETA(eta)}</p>
                </div>
              </div>

              <button 
                className="bg-card/95 backdrop-blur-sm rounded-lg p-3 shadow-lg border border-border hover:bg-muted transition-colors"
                aria-label="Centrer la carte"
              >
                <Icon name="Crosshair" size={20} />
              </button>
            </div>

            <div className="absolute bottom-4 left-4 bg-card/95 backdrop-blur-sm rounded-lg p-3 shadow-lg border border-border">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-3 h-3 rounded-full bg-success animate-pulse" />
                <span className="text-xs font-medium text-foreground">Position en temps réel</span>
              </div>
              <p className="text-xs text-muted-foreground">
                Dernière mise à jour : {new Date()?.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InteractiveMap;